import React from 'react';
import { AdminLayout } from '@/components/admin/AdminLayout';
import AdminOperatorsList from '@/components/admin/AdminOperatorsList';

const OperatorsPage: React.FC = () => {
  return (
    <AdminLayout>
      <div className="space-y-6">
        <div>
          <h1 className="text-3xl font-bold mb-1">Operators</h1>
          <p className="text-muted-foreground mb-6">Manage all operators on your platform.</p>
        </div>
        <AdminOperatorsList />
      </div>
    </AdminLayout>
  );
};

export default OperatorsPage; 